module.exports = __webpack_public_path__ + "img/p1.6c801648.jpg";